enum EnumCnesstSendStatus {
    Queued = 0,
    Success,
    FailedPermanent,
    FailedTemporary,
    Printed,
    Closed
}

export { EnumCnesstSendStatus };
